export default __webpack_public_path__ + "static/media/aim.d7302fc3.png";